import { CellTable } from "@/atoms"
import { AGENT_AI_DISCOVERY_DRAWER_ID } from "@/organisms/Drawers/const"
import { MoreTableCellDrawer } from "@/pages/DiscoveryPage/components/molecules/MoreTableCellDrawer"

import type { AiPolicyWorkloadAgent } from "@/api/useAiPolicies.types"
import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { TFunction } from "@/hooks/useTranslation"

// A workload's decision: the workload, then how many agents run in it, which
// its popup lists. An agent in the inventory opens its drawer, as an agent's
// decision does
export const WorkloadDecisionCell = (
  t: TFunction,
  onRowClick: RowClick,
  record: {
    key: string
    workload?: string
    workloadAgents?: AiPolicyWorkloadAgent[]
  }
) => {
  const tKey = "governance.ai.live.decisions"
  const agents = record.workloadAgents ?? []
  const workload = t(`${tKey}.workload`, { workload: record.workload ?? "" })

  if (!agents.length) return CellTable(workload)

  return MoreTableCellDrawer(onRowClick)({
    id: `workload-${record.key}`,
    label: `${workload} • ${t(`${tKey}.workloadAgents`, { count: agents.length })}`,
    // A count, even of none, keeps the label plain until hovered
    count: 0,
    title: t(`${tKey}.workloadAgentsTitle`),
    linkItems: true,
    items: agents.map(({ id, name, agentInventoryId }) => ({
      name: name || id,
      ...(agentInventoryId && {
        drawerId: AGENT_AI_DISCOVERY_DRAWER_ID,
        drawerEntityId: agentInventoryId
      })
    }))
  })
}
